import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const BoxTruck = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M27 4C25.346 4 24 5.346 24 7V17C24 18.654 22.654 20 21 20H5C4.448 20 4 20.448 4 21C4 21.552 4.448 22 5 22H6.538C6.197 22.589 6 23.272 6 24C6 26.206 7.794 28 10 28C12.206 28 14 26.206 14 24C14 23.272 13.803 22.589 13.462 22H18.538C18.197 22.589 18 23.272 18 24C18 26.206 19.794 28 22 28C24.206 28 26 26.206 26 24C26 22.656 25.333 21.466 24.313 20.74C25.347 19.823 26 18.487 26 17V7C26 6.449 26.449 6 27 6C27.551 6 28 5.552 28 5C28 4.448 27.552 4 27 4ZM12 24C12 25.103 11.103 26 10 26C8.897 26 8 25.103 8 24C8 22.897 8.897 22 10 22C11.103 22 12 22.897 12 24ZM22 26C20.897 26 20 25.103 20 24C20 22.897 20.897 22 22 22C23.103 22 24 22.897 24 24C24 25.103 23.103 26 22 26Z" />
		<path d="M11 18H19C20.654 18 22 16.654 22 15V13C22 12.232 21.71 11.531 21.234 11C21.71 10.469 22 9.768 22 9V7C22 5.346 20.654 4 19 4H15C13.346 4 12 5.346 12 7V9C12 9.351 12.061 9.687 12.172 10H11C9.346 10 8 11.346 8 13V15C8 16.654 9.346 18 11 18ZM14 9V7C14 6.449 14.449 6 15 6H19C19.551 6 20 6.449 20 7V9C20 9.551 19.551 10 19 10H15C14.449 10 14 9.551 14 9ZM10 13C10 12.449 10.449 12 11 12H19C19.551 12 20 12.449 20 13V15C20 15.551 19.551 16 19 16H11C10.449 16 10 15.551 10 15V13Z" />
	</svg>
);

export default BoxTruck;
